import "babel-polyfill";

import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import uuid from "uuid/v4";

import GlobalStyle from "styles/global";
import { ThemeProvider } from "styles/styled_components";
import THEME from "styles/theme";
import { SEGMENT_KEY } from "constants/app";
import { isProduction } from "helpers/env";
import configureStore from "store/configure_store";
import MicroAppContainer from "containers/micro_app_container";
import { initErrorReporting } from "helpers/error_reporting/error_reporting";
import ErrorBoundary from "components/error/error_boundary";

const store = configureStore();

if (
  isProduction() &&
  window.analytics &&
  typeof window.analytics.load === "function"
) {
  window.analytics.load(SEGMENT_KEY);
}

const sessionId = uuid();
initErrorReporting(sessionId);

render(
  <ThemeProvider theme={THEME}>
    <Provider store={store}>
      <Router>
        <ErrorBoundary>
          <MicroAppContainer />
          <GlobalStyle />
        </ErrorBoundary>
      </Router>
    </Provider>
  </ThemeProvider>,
  document.getElementById("root")
);
